<template>
  <div class="q-edit-content">
    <com-input
      v-if="!value.ext.edit"
      @focus="focus"
      :disabled="isPreview || isReplay"
      :type="value.style"
      :max-length="getLimitLength"
      :show-length="value.detail.format !== 'integer'"
      v-model="val"
    ></com-input>

    <div v-if="!value.ext.edit && errorTip" class="error-msg">
      {{ errorTip }}
    </div>
  </div>
</template>

<script>
import ComInput from "../input/com.vue";
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isPreview: Boolean,
    isReplay: Boolean,
  },
  components: {
    ComInput,
  },
  data() {
    return {
      val: "",
      styles: [
        {
          value: "text",
          label: this.$t("quest.k_3301"),
        },
        {
          value: "textarea",
          label: this.$t("quest.k_3302"),
        },
      ],
      formats: [
        {
          value: "",
          label: this.$t("quest.k_3303"),
        },
        {
          value: "email",
          label: this.$t("quest.k_3304"),
        },
        {
          value: "integer",
          label: this.$t("quest.k_3305"),
        },
      ],
      errorTip: "",
    };
  },
  methods: {
    focus() {
      this.errorTip = "";
    },
    check() {
      if (this.value.required === "Y" && !this.val) {
        this.errorTip = this.$t("form.form_1083");
        return false;
      } else if (this.value.detail.format === "email" && this.val) {
        this.value.verification = "Y";
        var re =
          /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
        if (!re.test(this.val)) {
          this.errorTip = this.$t("form.form_1010");
          return false;
        }
      } else if (this.val && this.value.detail.format === "integer") {
        var re = /^-?\d+$/;
        if (!re.test(this.val)) {
          this.errorTip = this.$t("quest.k_3306");
          return false;
        }
      }
      return {id: this.value.id, value: this.val};
    },
  },
  computed: {
    getLimitLength() {
      if (this.value.detail.format === "integer") {
        this.value.detail.max = 13;
      } else if (this.value.style === "text") {
        this.value.detail.max = 100;
      } else {
        this.value.detail.max = 100;
      }
      return this.value.detail.max;
    },
  },
  mounted() {
    //回显数据
    if (this.value.replayData) {
      this.val = this.value.replayData;
    }
  },
};
</script>

<style scoped lang="scss">
.q-edit-content {
  width: 100%;
  margin-top: 10px;
  ::v-deep {
    .com-input {
      &.code {
        margin-top: 5px;
        width: 60%;
      }
    }
    .com-button {
      font-size: 12px;
      padding: 6px 20px;
      &.code {
        margin-top: 5px;
        width: 39%;
        margin-left: 1px;
      }
    }
    .error-msg {
      position: absolute;
      color: #fc5659;
      padding-left: 10px;
      line-height: 20px;
      font-size: 12px;
    }
  }
}
</style>
